import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiPost } from '@services/service';
import { POST_RetrieveContactDetailsOnChange } from '@constants/end-points';


export const fetchContactDetailsInfo = createAsyncThunk<
  any,
  { contactid: any; lcid: string; datalang: string },
  { rejectValue: string }
>(
  'case/fetchContactDetailsInfo',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiPost(POST_RetrieveContactDetailsOnChange, payload);
      const data = JSON.parse(response?.data.contactdata)?.[0];

      return {
        ...data,
        UserId: [payload.contactid],
        phNumAlternateCountryCode: [""],
        countryId: [data.countryId],
        phNumCountryCode: [data?.countryId],
      };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Initial state for the slice
interface CaseState {
  contactDetails: any;
  loading: boolean;
  error: string | null;
}

const initialState: CaseState = {
  contactDetails: null,
  loading: false,
  error: null,
};

// Create the slice to manage state
const caseSlice = createSlice({
  name: 'case', // Slice name
  initialState, // Initial state
  reducers: {
    resetState: (state) => {
      state.contactDetails = null;
      state.error = null;
      state.loading = false;
    },
    clearContactDetails: (state) => {
      state.contactDetails = null; // Clears contact details only
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactDetailsInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactDetailsInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.contactDetails = action.payload;
      })
      .addCase(fetchContactDetailsInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;

      });
  },
});

// Export the actions
export const { resetState, clearContactDetails  } = caseSlice.actions;

export default caseSlice.reducer;
